import IndicationsScreen from './IndicationsScreen';
export default IndicationsScreen;
